import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps';
import PropTypes from 'prop-types';
import './LocationMap.css';
import { isMobile, isTablet } from '../lib/util';
import LocationItem from './LocationItem';

var red_icon = {
  url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
};

var orange_icon = {
  url: "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
};

class LocationMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      currActive: null,
      currCenter: null,
    };

    this.onToggleOpen = this.onToggleOpen.bind(this);
  }

  // this will only be called when page url is changed
  componentWillReceiveProps() {
    this.setState({
      currActive: null,
      currCenter: null,
    });
  }

  onToggleOpen(paramObj) {
    const offset = 0.01;
    const { idx, origin, location } = paramObj;
    this.setState({
      isOpen: origin === 'pin',
    });
    if (typeof idx !== 'undefined') {
      this.setState({
        currActive: idx,
        currCenter: {
          lat: location.map_lat + offset,
          lng: location.map_lng,
        },
      });
    } else {
      this.setState({
        currActive: null,
      });
    }
  }

  render() {
    let defaultCenter;
    let defaultZoom;
    switch (this.props.filter) {
      case 'north':
        defaultCenter = { lat: 25.0462495, lng: 121.4009959 };
        defaultZoom = 10;
        break;
      case 'central':
        defaultCenter = { lat: 24.4521675, lng: 120.7934309 };
        defaultZoom = 9;
        break;
      case 'south':
        defaultCenter = { lat: 23.2486285, lng: 120.6327558 };
        defaultZoom = 9;
        break;
      case 'east':
        defaultCenter = { lat: 23.5212991, lng: 121.315255 };
        defaultZoom = 9;
        break;
      default:
        defaultCenter = { lat: 24.3331373, lng: 120.9863347 };
        defaultZoom = 7;
    }
    if (isTablet()) {
      switch (this.props.filter) {
        case 'north':
          defaultCenter = { lat: 25.0462495, lng: 121.4009959 };
          defaultZoom = 9;
          break;
        case 'central':
          defaultCenter = { lat: 24.4521675, lng: 120.7934309 };
          defaultZoom = 8;
          break;
        case 'south':
          defaultCenter = { lat: 23.2486285, lng: 120.6327558 };
          defaultZoom = 8;
          break;
        case 'east':
          defaultCenter = { lat: 23.5212991, lng: 121.315255 };
          defaultZoom = 8;
          break;
        default:
          defaultCenter = { lat: 24.3331373, lng: 120.9863347 };
          defaultZoom = 7;
      }
    }
    if (isMobile()) {
      switch (this.props.filter) {
        case 'north':
          defaultCenter = { lat: 25.0462495, lng: 121.4009959 };
          defaultZoom = 8;
          break;
        case 'central':
          defaultCenter = { lat: 24.4521675, lng: 120.7934309 };
          defaultZoom = 8;
          break;
        case 'south':
          defaultCenter = { lat: 23.2486285, lng: 120.6327558 };
          defaultZoom = 7;
          break;
        case 'east':
          defaultCenter = { lat: 23.5212991, lng: 121.315255 };
          defaultZoom = 7;
          break;
        default:
          defaultCenter = { lat: 24.3331373, lng: 120.9863347 };
          defaultZoom = 6;
      }
    }
    return (
      <GoogleMap
        defaultZoom={defaultZoom}
        zoom={defaultZoom}
        defaultCenter={defaultCenter}
        center={this.state.currCenter || defaultCenter}
        defaultOptions={{ fullscreenControl: false, mapTypeControl: false }}
      >
        {this.props.isMarkerShown &&
          this.props.locations
            .filter((elem) => {
              if (!this.props.filter)
              {
                return elem.map_lat && elem.map_lng;
              }
              else if (elem.locationarea)
              {
                return this.props.filter === elem.locationarea.name && elem.map_lat && elem.map_lng;
              }else
              {
                return false
              }
            })
            .map((elem, idx) => (
              <Marker
                key={`marker${idx}`}
                position={{ lat: elem.map_lat, lng: elem.map_lng }}
                icon={elem.sub_title === '特約維修經銷商' ? orange_icon : red_icon}
                onClick={() => {
                  this.onToggleOpen({
                    idx,
                    origin: 'pin',
                    location: elem,
                  });
                }}
              >
                {/* open info */}
                {this.state.isOpen &&
                  this.state.currActive === idx && (
                    <InfoWindow
                      className="LocationMap-info-window"
                      onCloseClick={() => {
                        this.onToggleOpen({
                          origin: 'close',
                        });
                      }}
                    >
                      <LocationItem key={`location${idx}`} data={elem} isOnMap />
                    </InfoWindow>
                  )}
              </Marker>
            ))}
      </GoogleMap>
    );
  }
}

LocationMap.propTypes = {
  isMarkerShown: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  filter: PropTypes.string,
};

LocationMap.defaultProps = {
  filter: '',
};

export default withScriptjs(withGoogleMap(LocationMap));



// WEBPACK FOOTER //
// ./src/components/LocationMap.js